/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { PristynCareModal } from '../../../pages/dashboard/_modals/Futurisk/PristynCareModal'


type Props = {
    className: string
    title: string
    description: string
    avatar: string
    link: string | undefined
}

const PristynCareAdd: React.FC<Props> = ({ className }) => {
    const [modalShow, setModalShow] = useState(false);

    return (
        <div className='' style={{ padding: 0 }}>
            <a className={` hoverable   `} onClick={() => setModalShow(true)}>
                 <img src={toAbsoluteUrl('/media/partner/pristyn.png')} width="100%" alt='PristynCare' className='card-p-5 shadow' style={{ borderRadius: 8 }} />

            </a>
            <PristynCareModal show={modalShow} handleClose={() => setModalShow(false)} />
        </div>
    )


}

export { PristynCareAdd }
